import React from 'react';

const Corevalues = () => {
    return (
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-12.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">

                        <div className="section-heading mb-30">
                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}> Core Values </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out"></p>
                            <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                                <li style={{ position: 'relative', paddingLeft: '1em' }}>
                                    <span style={{ position: 'absolute', left: '0', color: 'gray', fontWeight: 'bold' }}>•</span>
                                    Client Focus: We prioritize client satisfaction by delivering tailored, results-oriented solutions.
                                </li>
                                <li style={{ position: 'relative', paddingLeft: '1em' }}>
                                    <span style={{ position: 'absolute', left: '0', color: 'gary', fontWeight: 'bold' }}>•</span>
                                    Adaptability: Staying agile in a rapidly evolving technological landscape.
                                </li>
                                <li style={{ position: 'relative', paddingLeft: '1em' }}>
                                    <span style={{ position: 'absolute', left: '0', color: 'gary', fontWeight: 'bold' }}>•</span>
                                    Empowerment: Enabling our clients and trainees to achieve their highest potential.
                                </li> <li style={{ position: 'relative', paddingLeft: '1em' }}>
                                    <span style={{ position: 'absolute', left: '0', color: 'gary', fontWeight: 'bold' }}>•</span>
                                    Innovation-Driven Excellence: Continuously improving and innovating to meet global standards.
                                </li> <li style={{ position: 'relative', paddingLeft: '1em' }}>
                                    <span style={{ position: 'absolute', left: '0', color: 'gary', fontWeight: 'bold' }}>•</span>
                                    Sustainability: Committed to ethical practices that contribute to long-term success for our clients and community.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Corevalues;